import queryString from 'query-string'
import _ from 'lodash'
import Promise from 'bluebird'

import config from '../../config'
import doFetch from './doFetch'

export const fetchPortal = id =>
  doFetch(config.apiEndpoint + `/portal/${id}`, {})
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => result.data)

export const fetchPortalByTown = town =>
  doFetch(config.apiEndpoint + `/portal?town=` + town, {})
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return _.orderBy(result.data, ['modifiedDate'], ['desc'])
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchPortalWithQuery = query => {
  query = _.omitBy(query, q => {
    if (_.isNumber(q)) {
      return false
    } else {
      return _.isEmpty(q)
    }
  })
  const queryStr = queryString.stringify(query)
  return doFetch(config.apiEndpoint + `/portal?${queryStr}`, {})
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return {
          data: result.data,
          pageCount: result.pageCount,
          limit: result.limit,
        }
      } else {
        throw new Error(result.reason)
      }
    })
}

export const createPortal = portal =>
  doFetch(config.apiEndpoint + `/portal`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      data: portal,
    }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const updatePortal = portal =>
  doFetch(config.apiEndpoint + `/portal/${portal._id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: portal }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw Error(result.reason)
      }
    })

export const deletePortal = portal =>
  doFetch(config.apiEndpoint + `/portal/${portal._id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => result.data)

export const fetchListing = listingID => {
  return doFetch(config.apiEndpoint + '/listing/' + listingID)
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })
}

export const deleteListing = listingID =>
  doFetch(config.apiEndpoint + `/listing/${listingID}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => result.data)

export const fetchListings = query =>
  doFetch(config.apiEndpoint + `/listing?${queryString.stringify(query)}`, {})
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchTowns = query =>
  doFetch(config.apiEndpoint + `/town?${queryString.stringify(query)}`, {})
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return _.sortBy(result.data, 'title.th')
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchTown = townID =>
  doFetch(config.apiEndpoint + `/town/${townID}`, {})
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchTags = tagName =>
  doFetch(config.apiEndpoint + `/tags?tagName=` + tagName, {})
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return _.chain(result.data)
          .map('_id')
          .sort()
          .value()
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchBanners = town =>
  doFetch(config.apiEndpoint + `/banner?town=` + town, {})
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return _.sortBy(result.data, 'appearSeq')
      } else {
        throw new Error(result.reason)
      }
    })

export const fetchPortalListings = query => {
  query = _.omitBy(query, _.isNull)
  const queryStr = queryString.stringify(query)
  return doFetch(config.apiEndpoint + `/portal-listing?` + queryStr, {})
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })
}

export const updateBanners = banners =>
  Promise.each(banners, banner => updateBanner(banner))

export const updateBanner = banner =>
  doFetch(config.apiEndpoint + `/banner/${banner._id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: banner }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw Error(result.reason)
      }
    })

export const createBanner = banner =>
  doFetch(config.apiEndpoint + `/banner`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({ data: banner }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw Error(result.reason)
      }
    })

export const deleteBanner = bannerID =>
  doFetch(config.apiEndpoint + `/banner/${bannerID}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const exportPortal = (portalID, exportListing) =>
  doFetch(config.apiEndpoint + `/export/` + portalID, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      data: exportListing,
    }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw new Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const createListing = listing =>
  doFetch(config.apiEndpoint + `/listing`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      data: listing,
    }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const updateListings = listings =>
  Promise.each(listings, listing => updateListing(listing))

export const updateListing = listing =>
  doFetch(config.apiEndpoint + `/listing/${listing._id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: listing }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw Error(result.reason)
      }
    })

export const generateQRCode = (text, imageID) => {
  const query = _.omitBy({ text, imageID }, _.isEmpty)
  const queryStr = queryString.stringify(query)
  return doFetch(config.apiEndpoint + `/generateQRCode?${queryStr}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.result === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })
}

export const fetchPortalHostByFields = (hostRef, fields) => {
  const query = _.omitBy({ fields }, _.isEmpty)
  const queryStr = queryString.stringify(query)
  return doFetch(config.apiEndpoint + `/portal/host/${hostRef}?${queryStr}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.status === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })
}

export const fetchContributors = () => {
  return doFetch(config.apiEndpoint + `/contributor`)
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.status === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })
}

export const fetchContributor = contributorID => {
  return doFetch(config.apiEndpoint + `/contributor/${contributorID}`)
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(json => {
      if (json.status === 'ok') {
        return json.data
      }
      throw new Error(json.reason)
    })
}

export const createContributor = contributor =>
  doFetch(config.apiEndpoint + `/contributor`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify({
      data: contributor,
    }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const updateContributor = contributor =>
  doFetch(config.apiEndpoint + `/contributor/${contributor._id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: contributor }),
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw Error(result.reason)
      }
    })

export const deleteContributor = contributorID =>
  doFetch(config.apiEndpoint + `/contributor/${contributorID}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })

export const updateScore = (collectionName, listScores) =>
  doFetch(config.apiEndpoint + `/${collectionName}/scores`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'PUT',
    body: JSON.stringify({ data: listScores }),
  })
    .then(response => {
      console.log(listScores)
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result
      } else {
        throw new Error(result.reason)
      }
    })

export const exportTownToWeb = townRef =>
  doFetch(config.apiEndpoint + `/export/web/towns/${townRef}`, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })
    .then(response => {
      if (response.ok) return response.json()
      throw Error(`${response.statusText} (${response.status})`)
    })
    .then(result => {
      if (result.status === 'ok') {
        return result.data
      } else {
        throw new Error(result.reason)
      }
    })



// WEBPACK FOOTER //
// ./src/modules/portal-remote/portalService.js